console.log("BEV RESTOCK JS LOADED - V2");

const BEV_RESTOCK_API = "https://infomatek.fr/reservation-api/restock-vote.php";
const BEV_RESTOCK_SESSION_KEY = "bev_restock_session";

function bevGetRestockSessionId(){
  let sessionId = localStorage.getItem(BEV_RESTOCK_SESSION_KEY);

  if(!sessionId){
    sessionId = crypto.randomUUID();
    localStorage.setItem(BEV_RESTOCK_SESSION_KEY, sessionId);
  }

  return sessionId;
}

function bevRenderRestockMessage(box, total){
  const msg = box.querySelector(".bev-restock-message");
  if(!msg) return;

  if(total === 0){
    msg.innerHTML = "✨ Soyez la première à demander son retour.";
  }else if(total === 1){
    msg.innerHTML = "💕 1 cliente souhaite déjà son retour.";
  }else{
    msg.innerHTML = "🔥 <strong>" + total + "</strong> clientes souhaitent déjà son retour !";
  }
}

function bevResetRestockBox(box){
  const title = box.querySelector(".bev-restock-title");
  const text = box.querySelector(".bev-restock-text");
  const btn = box.querySelector(".bev-restock-btn");
  const msg = box.querySelector(".bev-restock-message");

  if(title){
    title.innerHTML = "💕 Cet article a fait craquer beaucoup de clientes...";
  }

  if(text){
    text.innerHTML =
      "Il est malheureusement épuisé 😔<br>" +
      "Si vous souhaitez que Bev le recommande, faites-le lui savoir en un clic.";
  }

  if(btn){
    btn.style.display = "";
    btn.disabled = false;
    btn.innerHTML = "❤️ Je souhaite son retour";
  }

  if(msg){
    msg.innerHTML = "";
  }
}

function bevVariantIsReallyOutOfStock(variant){
  const inventory = Number(variant.inventory || 0);

  // Si Shopify dit disponible, ce n'est pas une rupture.
  if(variant.available === true){
    return false;
  }

  // Cas classique : stock Shopify géré et quantité 0.
  if(variant.inventory_management && inventory <= 0){
    return true;
  }

  // Sécurité : si inventory_management est vide mais inventory à 0,
  // on considère aussi comme rupture réelle.
  if(inventory <= 0){
    return true;
  }

  return false;
}

function bevVariantIsUnavailableBecauseOfMarketOrShipping(variant){
  const inventory = Number(variant.inventory || 0);

  // Shopify dit indisponible mais il reste du stock réel :
  // typiquement marché/pays/livraison non configuré.
  return variant.available === false && inventory > 0;
}

async function bevLoadRestockState(box){
  if(!box) return;

  const btn = box.querySelector(".bev-restock-btn");
  const msg = box.querySelector(".bev-restock-message");

  if(!btn || !msg) return;

  const sessionId = bevGetRestockSessionId();
  const variantId = box.dataset.variantId;

  if(!variantId) return;

  btn.disabled = false;
  btn.innerHTML = "❤️ Je souhaite son retour";
  msg.innerHTML = "Chargement...";

  try{
    const response = await fetch(
      BEV_RESTOCK_API +
      "?variant_id=" + encodeURIComponent(variantId) +
      "&session_id=" + encodeURIComponent(sessionId)
    );

    const data = await response.json();

    if(!data.success){
      msg.innerHTML = "";
      return;
    }

    bevRenderRestockMessage(box, Number(data.total || 0));

    if(data.already){
      btn.disabled = true;
      btn.innerHTML = "✓ Vous avez déjà participé";
    }

  }catch(error){
    console.error("Erreur chargement réassort", error);
    msg.innerHTML = "";
  }
}

async function bevSubmitRestockVote(box){
  if(!box) return;

  const btn = box.querySelector(".bev-restock-btn");
  const msg = box.querySelector(".bev-restock-message");

  if(!btn || !msg) return;

  const sessionId = bevGetRestockSessionId();

  btn.disabled = true;
  btn.textContent = "Envoi...";

  try{
    const response = await fetch(BEV_RESTOCK_API, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        product_id: box.dataset.productId,
        variant_id: box.dataset.variantId,
        session_id: sessionId
      })
    });

    const data = await response.json();

    if(data.success){
      btn.textContent = data.already
        ? "✓ Vous avez déjà participé"
        : "✓ Demande envoyée à Bev";

      bevRenderRestockMessage(box, Number(data.total || 0));
      return;
    }

    btn.disabled = false;
    btn.textContent = "❤️ Je souhaite son retour";

  }catch(error){
    console.error("Erreur vote réassort", error);
    btn.disabled = false;
    btn.textContent = "❤️ Je souhaite son retour";
  }
}

function bevGetCurrentVariantId(){
  const form =
    document.querySelector('form[action="/cart/add"]') ||
    document.querySelector('form[action*="/cart/add"]');

  const input = form?.querySelector('[name="id"]');

  return input?.value || null;
}

function bevUpdateRestockBoxForCurrentVariant(){
  const box = document.querySelector(".bev-restock-box");
  if(!box || !window.BEV_RESTOCK_VARIANTS) return;

  const variantId = bevGetCurrentVariantId();
  if(!variantId) return;

  const variant = window.BEV_RESTOCK_VARIANTS[String(variantId)];
  if(!variant) return;

  box.dataset.variantId = variantId;

const country = window.Shopify?.country || "";

if (
  variant.available === false &&
  ["BE", "ES", "PT", "CH"].includes(country)
) {
  box.style.display = "block";
  bevShowDeliveryUnavailableMessage(box);
  return;
}

if(bevVariantIsReallyOutOfStock(variant)){
  box.style.display = "block";
  bevResetRestockBox(box);
  bevLoadRestockState(box);
  return;
}

if(bevVariantIsUnavailableBecauseOfMarketOrShipping(variant)){
  box.style.display = "block";
  bevShowDeliveryUnavailableMessage(box);
  return;
}

  box.style.display = "none";
}

document.addEventListener("click", function(e){
  const btn = e.target.closest(".bev-restock-btn");
  if(!btn) return;

  const box = btn.closest(".bev-restock-box");
  if(!box) return;

  bevSubmitRestockVote(box);
});

document.addEventListener("change", function(){
  setTimeout(bevUpdateRestockBoxForCurrentVariant, 100);
});

document.addEventListener("click", function(e){
  if(
    e.target.closest("[data-option-value-id]") ||
    e.target.closest("[data-option-value]") ||
    e.target.closest(".variant-option") ||
    e.target.closest("variant-picker") ||
    e.target.closest("variant-selects")
  ){
    setTimeout(bevUpdateRestockBoxForCurrentVariant, 150);
    setTimeout(bevUpdateRestockBoxForCurrentVariant, 400);
  }
});

document.addEventListener("DOMContentLoaded", function(){
  setTimeout(bevUpdateRestockBoxForCurrentVariant, 300);
});